
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import COVERAPP from "@/utils/COVERAPP";
@Options({
  data() {
    return {
      // 右侧抽屉
      uprights: [
        {
          img: require("@/assets/img/right1.png"),
          activeImg: require("@/assets/img/active1.png"),
          smallYear: "2012",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/right2.png"),
          activeImg: require("@/assets/img/active2.png"),
          smallYear: "1978",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/right3.png"),
          activeImg: require("@/assets/img/active3.png"),
          smallYear: "1949",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/right4.png"),
          activeImg: require("@/assets/img/active4.png"),
          smallYear: "1921",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/share.png"),
          activeImg: require("@/assets/img/share.png"),
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
      ],
      uprightsOpen: -1,
      uprightsClose: -1,
      lightNum: -1,
      lightArr: [
        {
          start: new Date().getFullYear(),
          end: 2012,
        },
        {
          start: 2012,
          end: 1978,
        },
        {
          start: 1978,
          end: 1949,
        },
        {
          start: 1949,
          end: 1921,
        },
      ],
      // 事件list 第一维度
      yearArr: 0,
      // 事件缩放颗粒
      status: 1, // 1,2,3,4
      //弹框数据
      historyTitle: "",
      historyContent: "",
      historyId: "",
      historyVisible: false,
      showPosterBox: false,
      posterImg: "",
      statusChange: false, //控制动画
      isApp: false,
      openVisible: true,
      //收缩手势
      isGestureStart: false,
      startDst: 0,
      scale: 1,
      access:true//开机图
    };
  },
  computed: {
    ...mapState(["userInfo", "shareData", "activityData"]),
  },
  watch: {
    status: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        // console.log("新颗粒度，老颗粒度", val, oldVal);
        let self = this;
        if (val == 1) {
          self.yearArr = self.yearList1;
          self.getLength(self.yearList1);
        } else if (val == 2) {
          self.yearArr = self.yearList2;
          self.getLength(self.yearList2);
        } else if (val == 3) {
          self.yearArr = self.yearList3;
          self.getLength(self.yearList3);
        } else {
          self.yearArr = self.yearList4;
          self.getLength(self.yearList4);
        }
        if (oldVal) {
          self.statusChange = true;
          setTimeout(function () {
            self.statusChange = false;
          }, 3000);
        }
        self.$nextTick(function () {
          self.scrollEvent();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    let self = this;
    let homeShareData = JSON.parse(JSON.stringify(this.shareData));
    homeShareData.link = window.location.href;
    this.isApp = COVERAPP.Attribute.isApp();
    this.$common.onshare(homeShareData);
    this.getDetail();
    let square = document.getElementsByClassName("home-wrapper")[0];
    square.addEventListener("touchstart", function (event: any) {
      if (event.touches.length >= 2) {
        //标记已经触发了手势开始
        self.isGestureStart = true;
        //计算一下两个触点的初始距离
        self.startDst = self.getDst(event.touches[0], event.touches[1]);
      }
    });
    square.addEventListener("touchmove", function (event: any) {
      if (event.touches.length >= 2) {
        // 计算当前两个触点的距离
        let currentDst = self.getDst(event.touches[0], event.touches[1]);
        // 计算当前两个触点的距离 和 两个触点的初始距离 比例
        self.scale = currentDst / self.startDst;
      }
    });
    // 手势结束
    // 触发过手势开始并且有触摸结束的时候判断屏幕上手指数量 < 2
    square.addEventListener("touchend", function (event: any) {
      if (self.isGestureStart && event.touches.length < 2) {
        let status = self.status;
        if (self.scale > 1) {
          //放大
          // console.log("放大结束", self.scale);
          //多点触控时两手指越来越远
          if (status < 4) {
            self.status = status + 1;
            // console.log("放大后", self.status);
          } else {
            // console.log("已经最大了");
          }
        } else {
          //缩小
          // console.log("缩小结束", self.scale);
          if (status > 1) {
            self.status = status - 1;
            // console.log("缩小后", self.status);
          } else {
            // console.log("已经最小了");
          }
        }
        //重置标记
        self.isGestureStart = false;
        self.startDst = 0;
        self.scale = 1;
      }
    });
  },
  methods: {
    /**
     * 计算两个触点的位置
     * @param touch1 第一个触点
     * @param touch2 第二个触点
     */
    getDst(touch1, touch2) {
      //计算两个直角边的长度
      let x = touch2.clientX - touch1.clientX; //水平方向的距离
      var y = touch2.clientY - touch1.clientY; //垂直方向的距离
      //利用勾股定理，计算两个触点的距离（斜边的长度）
      var z = Math.sqrt(x * x + y * y);
      // 返回结果
      return z;
    },
    // 页面指南关闭
    closeOpen() {
      this.openVisible = false;
    },
    // 数据格式化
    getDetail() {
      let self = this;
      self
        .$requestTime(
          // "https://cover-api.test.thecover.cn/wap/getDSDataInfo",
          "https://api.thecover.cn/wap/getDSDataInfo",
          {},
          "get"
        )
        .then((data) => {
          if (data && data.time_data_url) {
            self
              .$requestTime(data.time_data_url, {}, "get")
              .then((data) => {
                data.reverse();
                let newArr1 = data.filter(function (item, index) {
                  return item.timeline_level && item.timeline_level == "1";
                });
                let newArr2 = data.filter(function (item, index) {
                  return (
                    item.timeline_level &&
                    (item.timeline_level == "1" || item.timeline_level == "2")
                  );
                });
                let newArr3 = data.filter(function (item, index) {
                  return item.timeline_level && !(item.timeline_level == "4");
                });
                let newArr4 = data.filter(function (item, index) {
                  return (
                    item.timeline_level && item.timeline_level.indexOf("/") < 0
                  );
                });
                // console.log("newArr1", newArr1);
                // console.log("newArr2", newArr2);
                // console.log("newArr3", newArr3);
                // console.log("newArr4", newArr4);
                let year1 = self.yearFormat(newArr1, 20);
                let year2 = self.yearFormat(newArr2, 10);
                let year3 = self.yearFormat(newArr3, 5);
                let year4 = self.yearFormat(newArr4, 1);
                self.yearList1 = year1;
                self.yearList2 = year2;
                self.yearList3 = year3;
                self.yearList4 = year4;
                self.yearArr = year1;
                self.getLength(this.yearArr);
                // console.log("year1", year1);
                // console.log("year2", year2);
                // console.log("year3", year3);
                // console.log("year4", year4);
                self.$common.pageLoaded();
                this.$common.track("load", "进入党史时间轴页面"); //埋点
              })
              .catch((res: any) => {});
          }
        })
        .catch((res: any) => {});
    },
    yearFormat(yearArr: Array<any>, status: number) {
      let yearLength = yearArr.length;
      let yearList = {};
      for (let i = 2021; i > 1921; i -= status) {
        let smallYear = i - status;
        let key = i + "-" + smallYear;
        yearList[key] = [];

        for (let j = 0; j < yearLength; j++) {
          let year = parseInt(yearArr[j].year);

          if (year == i && i == 2021) {
            yearList[key].push(yearArr[j]);
          } else if ((year < i && year > smallYear) || year == smallYear) {
            yearList[key].push(yearArr[j]);
          } else if (year == smallYear && smallYear == 1921) {
            yearList[key].push(yearArr[j]);
          }
        }
      }
      return yearList;
    },
    // 右侧打开功能（暂停使用）
    rightLeftTurn(index: number) {
      let last = this.uprightsNow;
      if (this.uprightsNow == index) {
        this.uprightsNow = -1;
        this.uprightsClose = index;
      } else {
        this.uprightsNow = index;
        this.uprightsClose = last;
      }
    },
    // 跳转百科及弹框开启关闭
    goWike() {
      // console.log("跳转到百科" + this.historyId);
      this.$common.track("click", `党史时间轴查看详情跳转百科`); //埋点
      window.location.href =
        // "https://cover-m.test.thecover.cn/history.html?id=" +
        "https://m.thecover.cn/history.html?id=" +
        this.historyId +
        "&source=dstimeline";
      // this.closeHistory();
    },
    openHistory(name: string, brief: string, id: string) {
      this.$common.track("click", `党史时间轴"${name}"事件被点击`); //埋点
      this.historyTitle = name;
      this.historyContent = brief;
      this.historyId = id;
      this.historyVisible = true;
    },
    closeHistory() {
      this.historyTitle = "";
      this.historyContent = "";
      this.historyId = "";
      this.historyVisible = false;
    },
    // 年份展示
    getLength(obj: object) {
      let num = 0;
      for (var item in obj) {
        num++;
      }
      this.yearListLength = num;
    },
    capitalizeStart: function (value) {
      return value.substring(0, 4);
    },
    capitalizeEnd: function (value) {
      return value.substring(5);
    },
    // 滚动监听
    scrollEvent(e) {
      let self = this;
      let arr = document.getElementsByClassName("yearStart") as any;
      let html = document.getElementsByTagName("html")[0] as any;
      let htmlFontS = parseFloat(html.style.fontSize);
      let height = self.$refs.timeLineBox.offsetHeight - htmlFontS * 3.3;
      let yearheight = htmlFontS * 0.3;
      // console.log(height,yearheight)
      let boxScrollTop = self.$refs.scrollDiv.scrollTop;
      // console.log('滚动条高度',boxScrollTop)
      let overYear = [] as any;
      for (let i = 0; i < arr.length; i++) {
        let year = arr[i].getElementsByClassName("content")[0].innerHTML;
        // console.log("年", year);
        if (arr[i].offsetTop <= boxScrollTop + height - yearheight) {
          // console.log(
          //   "年份，div距离，滚动高度",
          //   year,
          //   arr[i].offsetTop,
          //   boxScrollTop + height - yearheight
          // );
          overYear.push(year);
        }
      }
      let nowYear = overYear[overYear.length - 1];
      self.lightArr.map((item, index) => {
        if (
          (nowYear < item.start && nowYear > item.end) ||
          nowYear == item.end ||
          (nowYear == item.start && nowYear == 2021)
        ) {
          self.lightNum = index;
        }
      });
    },
    // 显示或隐藏海报、右侧按钮点击放到到最大颗粒且滑动到最小年
    clickRight(num) {
      let self = this;
      if (num == 4) {
        //海报
        if (!this.showPosterBox) {
          self.drawPoster();
          self.$common.track("click", `点击时间轴分享海报`); //埋点
        } else {
          self.showPosterBox = false;
        }
      } else {
        let lightNum = self.lightNum; //一进来可能是-1
        let smallYear = self.uprights[num].smallYear;
        // this.clickScroll = true;
        // if (lightNum != num) {
        //   //点击不是高亮的块
        //   this.lightNum = num;
        // }
        // console.log("高亮块，最小年", self.lightNum, smallYear);
        //点击跳转最大颗粒
        if (self.status < 4) {
          //不是最大颗粒度,放大到最大颗粒度,并跳转到该阶段最小年
          self.status = 4;
        } else {
          //是最大颗粒度,跳转到该阶段最小年
        }
        self.$nextTick(function () {
          let arr = document.getElementsByClassName("year") as any;
          for (let i = 0; i < arr.length; i++) {
            let year = arr[i].getElementsByClassName("content")[0].innerHTML;
            // console.log("每一年", year);
            if (year == smallYear) {
              // console.log("找到对应的年 年高度", year, arr[i].offsetTop);
              let html = document.getElementsByTagName("html")[0] as any;
              let htmlFontS = parseFloat(html.style.fontSize);
              let height = self.$refs.timeLineBox.offsetHeight - htmlFontS * 3.3;
              let yearheight = htmlFontS * 0.53;
              self.$refs.scrollDiv.scrollTop = arr[i].offsetTop - height + yearheight;
            }
          }
        });
      }
    },
    /*以下为生成分享图*/
    drawPoster() {
      let canvas = document.createElement("canvas");
      canvas.width = 1005;
      canvas.height = 1608;
      let ctx: any = canvas.getContext("2d");
      var posterImgs: any = [];
      posterImgs.push(
        this.defPreImage(require("../assets/img/map-poster.png"))
      );
      posterImgs.push(this.defPreImage(require("../assets/img/qrcode.png")));
      var that = this;
      Promise.all(posterImgs).then((imgs: any) => {
        ctx.drawImage(
          imgs[0],
          0,
          0,
          imgs[0].width,
          imgs[0].height,
          0,
          0,
          imgs[0].width,
          imgs[0].height
        );
        ctx.drawImage(
          imgs[1],
          0,
          0,
          imgs[1].width,
          imgs[1].height,
          1005 - imgs[1].width - 40,
          1588 - imgs[1].height,
          imgs[1].width,
          imgs[1].height
        );

        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("我是党史百年时间轴", 50, 980);
        ctx.fillText("第", 50, 1125);
        ctx.fillText("期待您的加入，共觅岁月峥嵘！", 50, 1250);

        //绘制字体
        ctx.font = 'bold 120px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        // 设置为粗体
        var beginTime = 1619316000;//2021-04-25 10:00:00
        console.log(Math.round(Date.now() / 1000) - beginTime)
        var textNum =
          30000000 +
          Math.round((Math.round(Date.now() / 1000) - beginTime) * 0.183);
        ctx.fillText(textNum, 150, 1110);

        var numberWidth = ctx.measureText(textNum).width;
        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("位探秘者", 180 + numberWidth, 1125);

        this.posterImg = canvas.toDataURL("image/jpeg");
        this.showPosterBox = true;
      });
    },
    //加载图片
    defPreImage(imgPath) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.crossOrigin = "Anonymous";
        img.src = imgPath;
      });
    },
    // 点击海报分享图片
    posterImgClick(e) {
      // console.log("点击图片");
      const _this = this;
      COVERAPP.Method.shareImage({
        image: e.target.src.split(";base64,")[1],
        title: _this.shareData.title,
        desc: _this.shareData.desc,
        imgUrl: _this.shareData.imgUrl,
        link: _this.shareData.link,
        callback(ret: any) {
          // const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
          // const origin = data.origin || ''
          // if (origin != 'None' && !_this.$common.isEmpty(origin)) {
          //     _this.$common.track('share', '分享图片到' + origin)
          // } else {
          //     _this.$common.track('share', '分享图片');
          // }
        },
      });
    },
    // 放大缩小
    turnScale(type) {
      let status = this.status;
      if (type == "big") {
        //放大
        this.status = status + 1;
        // console.log("放大后", this.status);
      } else {
        //缩小
        this.status = status - 1;
        // console.log("缩小后", this.status);
      }
    },
    // 进入页面
    accessPage(){
       this.access = false;
    }
  },
})
export default class Home extends Vue {}
